import { api, URLs } from '@/libs/api'
import type {
  AcceptInvitePayload,
  AcceptInviteResponse,
  ApiResponse,
  CancelInvitePayload,
  CreateInvitePayload,
  CreateInviteResponse,
  Invite,
  InviteParams,
} from '@/libs/interfaces'
import { invitesApiMock } from '@/libs/mocks/handlers/invites'

const invitesApiReal = {
  create: async (payload: CreateInvitePayload): Promise<CreateInviteResponse> => {
    const { orgID, ...body } = payload
    return await api
      .post<ApiResponse<CreateInviteResponse>>(URLs.Invites.create(orgID), body)
      .then((response) => response.data.data)
  },
  list: async (params: InviteParams): Promise<Invite[]> => {
    return await api
      .get<ApiResponse<Invite[]>>(URLs.Invites.list(params.orgID))
      .then((response) => response.data.data)
  },
  cancel: async (payload: CancelInvitePayload): Promise<Invite> => {
    const { orgID, inviteID } = payload
    return await api
      .delete<ApiResponse<Invite>>(URLs.Invites.cancel(orgID, inviteID))
      .then((response) => response.data.data)
  },
  accept: async (payload: AcceptInvitePayload): Promise<AcceptInviteResponse> => {
    const { userID, inviteToken } = payload
    return await api
      .post<ApiResponse<AcceptInviteResponse>>(URLs.Invites.accept(userID), { inviteToken })
      .then((response) => response.data.data)
  },
}

export const invitesApi: typeof invitesApiReal = __IS_MOCK_MODE__ ? invitesApiMock : invitesApiReal
